import React, { Component } from 'react';
import { backgroundImage, api, basic_api, imagePath } from './common';
import Footer from './Footer';
import Slider from "react-slick";
import Popup from "reactjs-popup";
import StarRatings from 'react-star-ratings';
import { connect } from 'react-redux'
import { withRouter, Link } from "react-router-dom";
// import {imagePath} from './common'

class Product extends Component {
  constructor(props) {
    super(props);
    this.scrollDiv = React.createRef();
    this.state = {
      data: [], div_show: false, show: false, rating: 0, name: "", email: "", number: '', editor: '', "errorName": false, "errorEmail": false, "errorEmails": false, "errorNumber": '', errorComment: '', errorMessage: '', reviewAllData: [], loader: false, reviewEmail: "", reviewTitle: "", rating: 0, reviewContent: "", reviewName: "", reviewerror: '', nav1: null,
      nav2: null, product_image: []
    };
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeRating = this.changeRating.bind(this);
    this.handleReview = this.handleReview.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  async componentDidMount() {
    window.scrollTo(0, 0)
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
    if (typeof (this.props.location.state) == "undefined") {
      this.props.history.push("/");
    } else {
      var collection_type = this.props.location.state.collection_type;
      var subcollection_type = this.props.location.state.subcollection_type;
      var product_name = this.props.location.state.product_name;
      var product_code = this.props.location.state.product_code;
      var product_brand = this.props.location.state.product_brand;
      var product_image = this.props.location.state.product_image;
      var product_information = this.props.location.state.product_information;
      var product_price = this.props.location.state.product_price;
      var currency_code=this.props.location.state.currency_code
      var currency_symbol=this.props.location.state.currency_symbol
      console.log(product_code, this.props.location.state, "product_code")
      await this.setState({ collection_type: collection_type, subcollection_type: subcollection_type, product_name: product_name, product_code: product_code, product_brand: product_brand, product_image: product_image.split(','), product_information: product_information, product_price: product_price,currency_symbol:currency_symbol ,currency_code:currency_code});
      this.get_all_revew()
      console.log(product_image.split(','), "product_image")

    }
  }
  handleClose() {
    this.setState({ show: false });
  }
  next() {
    this.slider1.slickNext();
  }
  previous() {
    this.slider1.slickPrev();
  }
  handleShow() {
    this.setState({ show: true });
  }

  async handleReview(event) {
    event.preventDefault();

    let { reviewName, reviewEmail, reviewContent, reviewTitle, rating } = this.state;
    var reviewData = localStorage.getItem(this.state.product_code + 'review');
    if (reviewName == "") {
      this.setState({ reviewerror: 'Please Enter Name' })
    } else {

      this.setState({ loader: true });
      var data = new FormData();
      data.append("action", "review")
      data.append("u_id", this.props.alldata.user_id)
      data.append("rw_p_code", this.state.product_code)
      data.append("rw_name", reviewName)
      data.append("rw_email", reviewEmail)
      data.append("rw_title", reviewTitle)
      data.append("rw_content", reviewContent)
      data.append("rate", rating)

      const requestOptions = {
        method: 'post',
        body: data
      };

      fetch(api + basic_api, requestOptions)
        .then((response) => response.json())
        .then(async (responseJson) => {

          console.log(responseJson, "responseJson")
          this.setState({ loader: false })
        })
        .catch((error) => {
          console.log(error, "error")
        });
      this.get_all_revew()
      this.setState({ reviewEmail: "", reviewTitle: "", rating: 0, reviewContent: "", reviewName: "" })
      // this.setState({ reviewAllData: data })

    }

  }


  get_all_revew = async () => {
    var data = new FormData();
    data.append("action", "get_review")
    data.append("u_id", this.props.alldata.user_id)
    data.append("rw_p_code", this.state.product_code)


    const requestOptions = {
      method: 'post',
      body: data
    };

    fetch(api + basic_api, requestOptions)
      .then((response) => response.json())
      .then(async (responseJson) => {

        console.log(responseJson, "responseJson")
        if (responseJson.success === "true") {
          await this.setState({ reviewAllData: responseJson.data });
        }
      })
      .catch((error) => {
        console.log(error, "error")
      });
  }
  handleSubmit = (event, close) => {
    event.preventDefault();
    var name = this.state.name;
    var email = this.state.email;
    var number = this.state.number;
    var editor = this.state.editor;
    var product_name = this.state.product_name;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (name === '' || name === null) {
      this.setState({ "errorMsg": "Please Enter Name", "errorName": true, "errorname": 'name' });
    } else if (!email.match(mailformat)) {
      this.setState({ "errorMsg": "Please Enter Valid Email Address", "errorEmails": true, "errorEmail": false, "errorName": false, "errorname": 'email' });
    } else if (number === '' || number === null) {
      this.setState({ "errorMsg": "Please Enter Contact Number", "errorEmails": false, "errorEmail": false, "errorName": false, "errorNumber": true, "errorname": 'number' });
    } else if (editor === '' || editor === null) {
      this.setState({ "errorMsg": "Please Enter Comment", "errorMessage": true, "errorEmail": false, "errorName": false, "errorEmails": false, "errorNumber": false, "errorname": 'editor' });
    } else {

      this.setState({ loader: true })
      var data = new FormData();
      data.append("action", "product_contact_us")
      data.append("u_id", this.props.alldata.user_id)
      data.append("p_code", this.state.product_code)
      data.append("u_name", name)
      data.append("u_email", email)
      data.append("u_contact", number)
      data.append("u_description", editor)
      // data.append("rate", this.state.name)
      //  console.log(data, "data")
      const requestOptions = {
        method: 'post',
        body: data
      };

      fetch(api + basic_api, requestOptions)
        .then((response) => response.json())
        .then(async (responseJson) => {

          close();
          console.log(responseJson, "responseJson api ")
          await this.setState({ "errorMessage": false, "errorEmail": false, "errorName": false, "errorEmails": false, "errorNumber": true, errorname: '', loader: false });

        })

        .catch((error) => {
          console.log(error, "error")
        });
    }
  }
  hide_show() {
    if (!this.state.div_show) {
      this.setState({ div_show: true });
    } else {
      this.setState({ div_show: false });
    }
  }
  changeRating(newRating, name) {
    console.log(newRating, name, "abbabbaba")
    this.setState({
      rating: newRating, reviewerror: ''
    });
  }

  render() {
    return (
      <div class="main_contact">
        <div className="middleContent main_contact">
          {/* <div class="headerImage" style="background-image: url('image/newsletter.png'); background-size: cover; background-position: center bottom; background-repeat: no-repeat; height: 250px; position: relative;">
          <div class="center_text">
              <h3>Diamond (Ring)</h3>
          </div>
      </div> */}
          {/*  */}
          <div className="page page_single_prodetail">
            <div className="container">
              <div className="center_text">
                <h3>Diamond (Ring)</h3>
              </div>
              <div className="single">
                <div className="single_box">
                  <div className="single__left">
                    <div className="productPhotos">
                      <div className="wrapper">
                        <Slider
                          className="product-slider"
                          asNavFor={this.state.nav2}
                          ref={slider => (this.slider1 = slider)}
                          arrows={false}
                        >
                          {this.state.product_image.map((image_name) =>
                            <div class="product-sli-item">
                              <div class="slide__picture">
                                {/* {<img  src={imagePath + ((this.state.product_image.split(','))[0])} />} */}
                                {this.state.product_image[0] && <img src={imagePath + image_name} />}
                              </div>
                            </div>
                          )}
                        </Slider>
                        <div className="pro-thumb-box">
                          <Slider

                            asNavFor={this.state.nav1}
                            ref={slider => (this.slider2 = slider)}
                            slidesToShow={3}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            arrows={false}
                          >
                            {this.state.product_image.map((image_name) =>
                              <div class="product-sli-item">
                                <div class="slide__picture">
                                  {/* {<img  src={imagePath + ((this.state.product_image.split(','))[0])} />} */}
                                  {this.state.product_image[0] && <img src={imagePath + image_name} />}
                                </div>
                              </div>
                            )}

                          </Slider>
                          <ul className="prevNext list-inline">
                            <li className="prev slick-arrow" style={{}} onClick={this.previous}>
                              <svg viewBox="0 0 512.008 512.008">
                                <path d="M501.342 245.185H36.424L210.227 71.404c4.093-4.237 3.975-10.99-.262-15.083-4.134-3.992-10.687-3.992-14.82 0l-192 192c-4.171 4.16-4.179 10.914-.019 15.085l.019.019 192 192c4.093 4.237 10.845 4.354 15.083.262 4.237-4.093 4.354-10.845.262-15.083a10.787 10.787 0 00-.262-.262L36.424 266.519h464.917c5.891 0 10.667-4.776 10.667-10.667s-4.775-10.667-10.666-10.667z" fill="#2196f3" />
                                <path d="M202.675 458.519a10.663 10.663 0 01-7.552-3.115l-192-192c-4.164-4.165-4.164-10.917 0-15.083l192-192c4.237-4.093 10.99-3.975 15.083.262 3.992 4.134 3.992 10.687 0 14.82L25.758 255.852 210.206 440.3c4.171 4.16 4.179 10.914.019 15.085a10.672 10.672 0 01-7.55 3.134z" />
                                <path d="M501.342 266.519H10.675c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667s-4.776 10.667-10.667 10.667z" />
                              </svg>
                            </li>
                            <li className="next slick-arrow" style={{}} onClick={this.next}>
                              <svg viewBox="0 0 512 512">
                                <path d="M511.189 259.954a10.667 10.667 0 00-2.325-11.627l-192-192c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l173.803 173.803H10.667C4.776 245.213 0 249.989 0 255.88c0 5.891 4.776 10.667 10.667 10.667h464.917L301.803 440.328c-4.237 4.093-4.355 10.845-.262 15.083 4.093 4.237 10.845 4.354 15.083.262.089-.086.176-.173.262-.262l192-192a10.693 10.693 0 002.303-3.457z" fill="#2196f3" />
                                <path d="M309.333 458.546a10.667 10.667 0 01-7.552-18.219l184.47-184.447-184.47-184.448c-4.093-4.237-3.975-10.99.262-15.083 4.134-3.992 10.687-3.992 14.82 0l192 192c4.164 4.165 4.164 10.917 0 15.083l-192 192a10.66 10.66 0 01-7.53 3.114z" />
                                <path d="M501.333 266.546H10.667C4.776 266.546 0 261.771 0 255.88s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667-.001 5.891-4.777 10.666-10.668 10.666z" />
                              </svg>
                            </li>
                          </ul>

                        </div>


                      </div>
                    </div>
                  </div>
                  <div className="single__right">
                    <a href="/de-de/designers/max-mara" className="single-by single-by_link" data-test="brand-name">{this.state.product_name}
                    </a>
                    <h1 data-test="product-name" className="single-name">{this.state.product_brand} </h1>
                    <div className="single-price">

                      <div data-test="price-current" className="single-price__current">
                      {this.state.currency_symbol}: {this.state.currency_code==="EUR" ?(this.state.product_price*0.012).toFixed(3): this.state.currency_code==="USD" ?(this.state.product_price*0.014).toFixed(3):this.state.currency_code==="AED"?(this.state.product_price*0.051).toFixed(3):this.state.product_price}

                      </div>
                    </div>

                    <div className="single-actions">

                      <Popup trigger={<button className="btn single-actions__to-cart btn_null btn_block" data-test="Add to cart-btn">
                        <svg width="20px" height="20px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3.5 4A1.5 1.5 0 002 5.5v9A1.5 1.5 0 003.5 16h13a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0016.5 4h-13zm2.015 2.143a1 1 0 10-1.03 1.714l5 3a1 1 0 001.03 0l5-3a1 1 0 10-1.03-1.714L10 8.833l-4.485-2.69z" /></svg>
                        <div className="btn__name">Contact</div>
                      </button>} modal>
                        {close => (

                          <div className="modal_">
                            <a className="close" onClick={close}>
                              &times;
                          </a>
                            <h4 className="rmv-padding text-center modal_title">{this.state.product_name}</h4>
                            <form onSubmit={(e) => this.handleSubmit(e, close)}>
                              <div class="col-xs-12">
                                <div class="form-group">
                                  <label className="modal_label">Name</label>
                                  <input type="text" className="form-control" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value, errorMsg: '' })} />
                                  {this.state.errorname == "name" &&
                                    <h6 className="Erro_msg">{this.state.errorMsg}</h6>
                                  }
                                </div>
                                <div class="form-group">
                                  <label className="modal_label">Email ID</label>
                                  <input type="text" className="form-control" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value, errorMsg: '' })} />
                                  {this.state.errorname == "email" &&
                                    <h6 className="Erro_msg">{this.state.errorMsg}</h6>
                                  }
                                  {this.state.errorname == "email" &&
                                    <h6 className="Erro_msg">{this.state.errorMsg}</h6>
                                  }
                                </div>
                                <div class="form-group">
                                  <label className="modal_label">Contact Number</label>
                                  <input type="text" className="form-control" maxLength={14} value={this.state.number} onChange={(e) => {
                                    var phone = e.target.value.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                                    this.setState({ number: phone, errorMsg: '' })
                                  }} />
                                  {this.state.errorname == "number" &&

                                    <h6 className="Erro_msg">{this.state.errorMsg}</h6>
                                  }
                                </div>
                              </div>
                              <div class="col-xs-12">
                                <div class="form-group">
                                  <label className="modal_label">WHAT WOULD YOU LIKE TO CHANGE IN THIS DESIGN?</label>
                                  <textarea value={this.state.editor} onChange={(e) => this.setState({ editor: e.target.value, errorMsg: '' })} name="body" className="form-control" rows="4" />
                                  {this.state.errorname == "editor" &&
                                    <h6 className="Erro_msg">{this.state.errorMsg}</h6>
                                  }
                                </div>
                                <input type="submit" value="SUBMIT" class="form-control modal_submit_btn" onClick={() => close} />
                              </div>
                            </form>
                          </div>
                        )}
                      </Popup>
                    </div>
                    <div className="single-description">
                      <p>{this.state.product_information}</p>
                    </div>
                  </div>
                </div>
                <div className="single__bottom">
                  <div className="review">
                    <div className="review-box w-left">
                      <div className="main_review">
                        <div className="review_title_div">
                          <h3 className="review_title">Write Your Review</h3>
                          <div className="star-box">
                            <div className="star-i"><span className="star_span">★</span><span className="star_span">★</span><span className="star_span">★</span><span className="star_span">★</span><span className="star_span">★</span><span style={{ paddingLeft: 15, color: 'rgb(0, 0, 0)', fontSize: 16 }}>Based on 5 reviews</span></div>
                            <a className="review-write" rel="review" onClick={() => { this.hide_show(); }}  >Write Your Review</a>
                          </div>
                        </div>
                        <div className={this.state.div_show ? 'writereview_content show' : 'writereview_content hide'}>
                          <form onSubmit={this.handleReview}>
                            <div className="form-group"><label className="review_label">Name</label>
                              <input type="text" className="form-control review_input" value={this.state.reviewName} onChange={(e) => { this.setState({ reviewName: e.target.value, reviewerror: '' }) }} /></div>
                            <div className="form-group"><label className="review_label">Email</label>
                              <input type="text" className="form-control review_input" value={this.state.reviewEmail} onChange={(e) => this.setState({ reviewEmail: e.target.value })} /></div>
                            <div className="form-group">
                              <label className="review_label">Rating</label>
                              <div>
                                <StarRatings
                                  rating={this.state.rating}
                                  starRatedColor="#947b4a"
                                  changeRating={this.changeRating}
                                  numberOfStars={5}
                                  starDimension='20px'
                                  starHoverColor="#947b4a"
                                  name='rating'
                                  starSpacing={'2px'}
                                />
                              </div>
                            </div>
                            <div className="form-group"><label className="review_label">Review Title</label>
                              <input type="text" className="form-control review_input" value={this.state.reviewTitle} onChange={(e) => this.setState({ reviewTitle: e.target.value })} /></div>
                            <div className="form-group"><label className="review_label">Review Content</label>
                              <textarea name="body" className="form-control review_input" rows={4} value={this.state.reviewContent} onChange={(e) => this.setState({ reviewContent: e.target.value })} /></div>
                            <div className="form-group review-submit">
                              <input type="submit" className="review_submit_btn" disabled={this.state.loader} style={this.state.loader ? { "opacity": "0.5" } : {}} />
                              <h6 className="Erro_msg">{this.state.reviewerror}</h6>
                            </div>
                          </form>
                          <hr className="review-input-title" />
                        </div>
                      </div>
                      <div className="main_review customerReview">
                        {(this.state.reviewAllData.length > 0) && <div className="review_title_div">
                          <h3 className="review_title">Customer Reviews</h3>
                        </div>}

                        {(this.state.reviewAllData.length > 0) &&
                          this.state.reviewAllData.map(function (x, i) {
                            let abc = x.rw_name;
                            return <div className="userImgReview">
                              <div className="userImg">
                                <div className="userBg"><span className="crl">{abc.charAt(0)}</span></div>
                              </div>

                              <div className="">
                                <h6>{x.rw_name}</h6>
                                <StarRatings
                                  rating={parseInt(x.rate)}
                                  starDimension="15px"
                                  starSpacing="0"
                                  starRatedColor="#feb640"
                                />
                                <span>{x.rw_title}</span>
                                <p>{x.rw_content}</p>
                              </div>
                            </div>;
                          })}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {<div className="new_collection related-slider-box not-bg w-left">
      <div className="container">
        <div className="row">
          <div className="jewe_title">
            <h3>You may also like</h3>
          </div>
          <div className="new_collection_slider related-slider">
            <div className="newslideitem">
              <img src="image/gold_1.png" />
            </div>
            <div className="newslideitem">
              <img src="image/hoops_1.jpg" />
            </div>
            <div className="newslideitem">
              <img src="image/pendant_1.jpg" />
            </div>
            <div className="newslideitem">
              <img src="image/silver_1.png" />
            </div>
            <div className="newslideitem">
              <img src="image/gemstone_3.png" />
            </div>
            <div className="newslideitem">
              <img src="image/ring_1.png" />
            </div>
            <div className="newslideitem">
              <img src="image/product_1.jpg" />
            </div>
          </div>
          <ul className="prevNext list-inline">
            <li className="prev">
              <svg viewBox="0 0 512.008 512.008">
                <path d="M501.342 245.185H36.424L210.227 71.404c4.093-4.237 3.975-10.99-.262-15.083-4.134-3.992-10.687-3.992-14.82 0l-192 192c-4.171 4.16-4.179 10.914-.019 15.085l.019.019 192 192c4.093 4.237 10.845 4.354 15.083.262 4.237-4.093 4.354-10.845.262-15.083a10.787 10.787 0 00-.262-.262L36.424 266.519h464.917c5.891 0 10.667-4.776 10.667-10.667s-4.775-10.667-10.666-10.667z" fill="#2196f3" />
                <path d="M202.675 458.519a10.663 10.663 0 01-7.552-3.115l-192-192c-4.164-4.165-4.164-10.917 0-15.083l192-192c4.237-4.093 10.99-3.975 15.083.262 3.992 4.134 3.992 10.687 0 14.82L25.758 255.852 210.206 440.3c4.171 4.16 4.179 10.914.019 15.085a10.672 10.672 0 01-7.55 3.134z" />
                <path d="M501.342 266.519H10.675c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667s-4.776 10.667-10.667 10.667z" />
              </svg>
            </li>
            <li className="next">
              <svg viewBox="0 0 512 512">
                <path d="M511.189 259.954a10.667 10.667 0 00-2.325-11.627l-192-192c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l173.803 173.803H10.667C4.776 245.213 0 249.989 0 255.88c0 5.891 4.776 10.667 10.667 10.667h464.917L301.803 440.328c-4.237 4.093-4.355 10.845-.262 15.083 4.093 4.237 10.845 4.354 15.083.262.089-.086.176-.173.262-.262l192-192a10.693 10.693 0 002.303-3.457z" fill="#2196f3" />
                <path d="M309.333 458.546a10.667 10.667 0 01-7.552-18.219l184.47-184.447-184.47-184.448c-4.093-4.237-3.975-10.99.262-15.083 4.134-3.992 10.687-3.992 14.82 0l192 192c4.164 4.165 4.164 10.917 0 15.083l-192 192a10.66 10.66 0 01-7.53 3.114z" />
                <path d="M501.333 266.546H10.667C4.776 266.546 0 261.771 0 255.88s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667-.001 5.891-4.777 10.666-10.668 10.666z" />                                    
              </svg>
            </li>
          </ul>
        </div>
      </div>
    </div>} */}
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  console.log(state, "state")
  return {
    alldata: state.responseJson,

  }
}

export default connect(mapStateToProps)(withRouter(Product));
//export default Product;


